import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styles from './ManageAccount.module.css';
import Paddle from '../../Paddle/Paddle';

const ManageAccount = () => {
    const navigate = useNavigate();
    const username = useSelector((state) => state.user.username);
    const firstname = useSelector((state) => state.user.firstname);
    const lastname = useSelector((state) => state.user.lastname);
    const nickname = useSelector((state) => state.user.nickname);
    const email = useSelector((state) => state.user.email);

    return (
        <div className={styles.container}>
            <button className={styles.backButton} onClick={() => navigate(-1)}>← Back</button>
            <h1 className={styles.title}>Manage Account</h1>

            <div className={styles.paddleWrapper}>
            <Paddle
                username={username}
                name={`${firstname} ${lastname}`}
                nickname={nickname}
                email={email}
            />
            </div>

            <div className={styles.buttonContainer}>
                <button className={styles.button} onClick={() => navigate('/changeusername')}>Change Username</button>
                <button className={styles.button} onClick={() => navigate('/changenickname')}>Change Nickname</button>
                <button className={styles.button} onClick={() => navigate('/changepassword')}>Change Password</button>
                <button className={styles.button} onClick={() => navigate('/changeemail')}>Change Email</button>
            </div>
        </div>
    );
};

export default ManageAccount;
